/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Build_AssistantsInputs */



/**
* | output |
* | --- |
* | "Build AI assistants for my team" |
*
* @param {Onboarding_Usage_Build_AssistantsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_build_assistants = /** @type {((inputs?: Onboarding_Usage_Build_AssistantsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Build_AssistantsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Assistenten für mein Team erstellen")
	return /** @type {LocalizedString} */ ("Build AI assistants for my team")
});